import styled from "styled-components";
import { TOPBAR_H } from "../../config/layout";

export const Page = styled.div`
  height: 100vh;
  /* Hueco para la cabecera fija */
  padding-top: ${TOPBAR_H};
  box-sizing: border-box;
  overflow: hidden;
  background: #3a3a3a;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 24px;
  padding: 28px;

  @media (max-width: 1100px) {
    flex-direction: column;
  }
`;

export const VideoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
  flex: 1;

  @media (max-width: 1100px) {
    flex: 1;
  }
`;

/* En modo ampliado el escenario es el contenedor de posicionamiento: los dos
   vídeos siguen montados y solo cambian de sitio, para no perder el srcObject. */
export const Stage = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: ${({ $expanded }) => ($expanded ? "relative" : "static")};
`;

export const Tile = styled.div`
  position: ${({ $expanded }) => ($expanded ? "absolute" : "relative")};
  overflow: hidden;
  border-radius: 12px;
  background: #111;
  display: ${({ $hidden }) => ($hidden ? "none" : "block")};

  ${({ $expanded, $pip }) => {
    if (!$expanded) return "flex: 1; min-height: 0;";
    if ($pip) {
      return `
        right: 18px;
        bottom: 18px;
        width: 260px;
        height: 150px;
        border: 3px solid #fff;
        z-index: 2;
      `;
    }
    return "inset: 0;";
  }}
`;

export const Icon = styled.img`
  width: ${({ $size }) => $size || 44}px;
  height: ${({ $size }) => $size || 44}px;
  object-fit: contain;
  display: block;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #111;
  display: block;
`;

/* ---- Controles ---- */
export const ControlBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #2b2b2b;
  border-radius: 34px;
  padding: 10px 14px;
  flex-shrink: 0;

  ${({ $floating }) => $floating && `
    min-width: 320px;
    position: absolute;
    left: 50%;
    bottom: 22px;
    transform: translateX(-50%);
    z-index: 3;
    background: rgba(30, 30, 30, 0.85);
  `}
`;

export const ControlGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CircleButton = styled.button`
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover { background: rgba(255, 255, 255, 0.12); }
  &:disabled { opacity: 0.35; cursor: not-allowed; }
`;

export const HangUpButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 22px;
  border-radius: 24px;
  border: none;
  background: #f4685e;
  color: #fff;
  font-size: 0.9rem;
  cursor: pointer;
  white-space: nowrap;

  &:hover { background: #e0554b; }
`;

/* Botón flotante en la esquina del vídeo: ampliar en la vista normal,
   intercambiar en la miniatura del modo ampliado. */
export const TileButton = styled.button`
  position: absolute;
  right: 12px;
  bottom: 12px;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 3;

  &:hover { opacity: 0.85; }
`;

/* ---- Chat ---- */
export const ChatColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: ${({ $hidden }) => ($hidden ? "none" : "block")};
`;

/* ---- Estados previos a la llamada ---- */
export const StatusBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #fff;
  font-size: 0.9rem;
  flex-shrink: 0;
`;

export const AnswerButton = styled.button`
  padding: 11px 24px;
  border-radius: 24px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #175a65; }
`;
